import qs from 'query-string'

export const getQueryString = () => window.location.search

export const getParamsFromQueryString = () => {
  const rawQueryString = getQueryString()

  return qs.parse(rawQueryString)
}

export const redirectToApp = (urlRedirect, token) => {
  const appUrl = qs.parseUrl(urlRedirect)
  return window.location.assign(`${appUrl.url}?${qs.stringify({ ...appUrl.query, token }, { encode: false })}`)
}
